import * as UserType from "enums/UserType"
import * as AdvertType from "enums/AdvertType"
import * as BudgetOwnerSharing from "enums/BudgetOwnerSharing"
import { Tag, TagsList } from "components/Tag"
import { useTranslator } from "components/Translator"
import { formatPrice } from "components/Price"
import { Section } from "components/Section"

export const BudgetSection = ({ entity }) => {
  const translator = useTranslator()

  const entityTypeToComponent = {
    [UserType.CREW]: BudgetCrewSection,
    [UserType.OWNER]: BudgetOwnerSection,
    [AdvertType.CREW]: BudgetCrewSection,
    [AdvertType.BOAT]: BudgetOwnerSection,
  }

  const Component = entityTypeToComponent[entity.type.enum_value]

  if (!Component) {
    return null
  }

  return (
    <>
      <Section
        aria-labelledby={translator.trans(
          "BudgetSection.budget",
          null,
          "components",
        )}
        className="space-y-4 py-8"
      >
        <Section.Title>
          {translator.trans("BudgetSection.budget", null, "components")}
        </Section.Title>
        <Component entity={entity} />
      </Section>
    </>
  )
}

const BudgetCrewSection = ({ entity }) => {
  const budget = entity.budgetCrew

  return (
    <TagsList>
      {budget.choice ? <Tag label={budget.choice.enum_label} tag="li" /> : null}
      {budget.sharing?.map((item) => (
        <Tag key={item.enum_value} label={item.enum_label} tag="li" />
      ))}
      {budget.other?.map((item) => (
        <Tag key={item.enum_value} label={item.enum_label} tag="li" />
      ))}
    </TagsList>
  )
}

const BudgetOwnerSection = ({ entity }) => {
  const translator = useTranslator()
  const budget = entity.budgetOwner

  return (
    <TagsList>
      {budget.choice ? <Tag label={budget.choice.enum_label} tag="li" /> : null}
      {budget.sharing?.map((item) =>
        item.enum_value == BudgetOwnerSharing.POT &&
        budget.sharingPot?.amount !== null &&
        budget.sharingPot?.amount > 0 &&
        budget.sharingPot?.currency !== null ? (
          <Tag
            key={"sharingPot"}
            label={translator.trans(
              "BudgetSection.sharingPot",
              {
                price: formatPrice({
                  amount: budget.sharingPot.amount,
                  currency: budget.sharingPot.currency.enum_value,
                  locale: translator.locale,
                }),
              },
              "components",
            )}
            tag="li"
          />
        ) : item.enum_value == BudgetOwnerSharing.MAINTENANCE &&
          budget.sharingMaintenance?.amount !== null &&
          budget.sharingMaintenance?.amount > 0 &&
          budget.sharingMaintenance?.currency !== null ? (
          <Tag
            label={translator.trans(
              "BudgetSection.sharingMaintenance",
              {
                price: formatPrice({
                  amount: budget.sharingMaintenance.amount,
                  currency: budget.sharingMaintenance.currency.enum_value,
                  locale: translator.locale,
                }),
              },
              "components",
            )}
            tag="li"
          />
        ) : (
          <Tag key={item.enum_value} label={item.enum_label} tag="li" />
        ),
      )}
      {budget.pro.price?.amount !== null &&
      budget.pro.price?.amount > 0 &&
      budget.pro.price?.currency !== null &&
      budget.pro.priceMeasure !== null &&
      budget.pro.priceFrequency !== null ? (
        <Tag
          label={translator.trans(
            "BudgetSection.pro.price",
            {
              price: formatPrice({
                amount: budget.pro.price.amount,
                currency: budget.pro.price.currency.enum_value,
                locale: translator.locale,
              }),
              unit: `/${budget.pro.priceMeasure.enum_label}/${budget.pro.priceFrequency.enum_label}`,
            },
            "components",
          )}
          tag="li"
        />
      ) : null}
      {budget.pro.pot?.amount !== null &&
      budget.pro.pot?.amount > 0 &&
      budget.pro.pot?.currency !== null ? (
        <Tag
          label={translator.trans(
            "BudgetSection.sharingPot",
            {
              price: formatPrice({
                amount: budget.pro.pot.amount,
                currency: budget.pro.pot.currency.enum_value,
                locale: translator.locale,
              }),
            },
            "components",
          )}
          tag="li"
        />
      ) : null}
    </TagsList>
  )
}
